import React, { useState } from "react";

import Card from "./Card";

import theme, { navbarHeight } from "../../../utils/styles";
import data from "../../../data/mission";

const Mission = (props) => {
  const { yOffset } = props;
  const { isBreakpoint } = props;

  const documentHeight = window.innerHeight;

  let scrolledPercentage = Math.floor((yOffset / documentHeight) * 100);
  let scrolledInPercentage;

  let showCards = false;

  if (scrolledPercentage > 10) {
    scrolledInPercentage = 100;
  }

  if (scrolledPercentage > 70) {
    showCards = true;
  }

  const opacity = String(scrolledInPercentage) + "%";

  const [hover, setHover] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(null);

  const renderCards = data.cards.map((card, index) => (
    <div
      onMouseEnter={(e) => {
        setHover(true);
        setHoverIndex(index);
      }}
      onMouseLeave={(e) => {
        setHover(false);
        setHoverIndex(null);
      }}
      key={index}
    >
      <Card
        data={card}
        show={showCards}
        index={index}
        hover={hover}
        hoverIndex={hoverIndex}
        isBreakpoint={isBreakpoint}
      />
    </div>
  ));

  return (
    <div style={styles.root} id="#mission">
      <div style={styles.cardsContainer(opacity, isBreakpoint)}>
        {renderCards}
      </div>
    </div>
  );
};

export default Mission;

const gap = (isBreakpoint) => {
  const large = 30;
  const medium = 20;

  return isBreakpoint ? medium : large;
};

const styles = {
  root: {
    minHeight: "100vh",
    background: theme.colors.background,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cardsContainer: (opacity, isBreakpoint) => ({
    opacity: opacity,
    transition: "ease-in-out 0.5s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    rowGap: gap(isBreakpoint),
    columnGap: gap(isBreakpoint),
    margin: navbarHeight * 1.5 + "px 0px",
    // background: "red",
  }),
};
